export default class ErrorLogModel {
  id?: number;
  timestamp = new Date();
  source = '';
  url = '';
  message = '';
  userId = ''; //implment once we have SSO
}
